export default __webpack_public_path__ + "static/media/006.ab89f5de.jpg";